import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 100%;
  @media screen and (max-width: 768px) {
  }
`;

export const NotificationIcon = styled.div`
  padding: 0 10px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media screen and (max-width: 768px) {
  }
`;

export const NotificationsContainer = styled.div`
  display: none;
  background-color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  height: 400px;
  position: absolute;
//   top: 40px;
// bottom: 0;
  right: -50px;
  width: 300px;
  z-index: 1001;
  border: 1px solid #d1d1d1;
  flex-direction: column;
  gap: 10px;
    &.show{
        display: flex;
    }
    &.hide {
        display: none;
    }
  @media screen and (max-width: 768px) {
    // height: 100%;
  }
`;
export const NotiListItem = styled.div`
  display: flex;
  gap: 10px;
  & > button{
    display: none;
  }
  &:hover > button {
    display: block;
    cursor: pointer;
    background-color: #ffffff;
    border: none;
    padding: 0;
  }
  @media screen and (max-width: 768px) {
  }
`;
export const NotificationNumber = styled.div`
  position: absolute;
    top: 18px;
    right: 8px;
    background-color: red;
    color: white;
    font-size: 10px;
    font-weight: bold;
    border-radius: 50%;
    // padding: 2px 6px;
    width: 12px;
    height: 12px;
    text-align: center;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    // transform: translate(50%, -50%);

  @media screen and (max-width: 768px) {
  }
`;